import * as React from 'react';
import cx from 'classnames';
import scrollUtil from 'utils/scrollUtil';
import throttle from 'lodash/throttle';
import { EasingEquationIdent } from 'utils/easingEquations';
import styles from './Help.css';
export default class Help extends React.Component {
    constructor(props) {
        super(props);
        this.handleEscape = (event) => {
            if (event.keyCode === 27) {
                this.setState({ active: false });
            }
        };
        this.handleClick = (event) => {
            this.setState({ active: !this.state.active }, () => {
                this.props.onClick && this.props.onClick(this.state.active);
            });
            event.preventDefault();
            event.stopPropagation();
        };
        this.handleResize = () => {
            this.innerHeight = window.innerHeight;
        };
        this.tooltipRef = (c) => (this.tooltip = c);
        this.state = {
            active: props.active || false // user can control if this needs to be active or not.
        };
        this.hasKeyUpEvent = false;
        this.handleResize = throttle(this.handleResize.bind(this));
        this.handleResize();
    }
    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
    }
    shouldComponentUpdate(nextProps, nextState) {
        return !(this.state.active === nextState.active) || !(this.props.text === nextProps.text);
    }
    componentDidUpdate() {
        if (this.state.active) {
            window.addEventListener('keyup', this.handleEscape);
            if (!this.tooltip)
                return;
            this.hasKeyUpEvent = true;
            const box = this.tooltip.getBoundingClientRect();
            let scroll = 0;
            if (this.props.position.match(/^bottom/) && box.bottom - this.innerHeight > -5) {
                scroll = box.bottom - this.innerHeight + 10;
            }
            if (this.props.position.match(/^top/) && box.top < 85) {
                scroll = box.top - 85;
            }
            if (scroll !== 0) {
                this.scrollIntoView(scroll);
                // need to call it twice due to problems with sticky components
                setTimeout(() => this.scrollIntoView(scroll), 20);
            }
            typeof this.props.onShow === 'function' && this.props.onShow();
        }
        else {
            this.hasKeyUpEvent && window.removeEventListener('keyup', this.handleEscape);
            typeof this.props.onHide === 'function' && this.props.onHide();
        }
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({ active: !!nextProps.active });
    }
    componentWillUnmount() {
        this.hasKeyUpEvent && window.removeEventListener('keyup', this.handleEscape);
        window.removeEventListener('resize', this.handleResize);
    }
    scrollIntoView(y) {
        scrollUtil(y, 0.4, EasingEquationIdent.easeInOutSine, window);
    }
    renderContent() {
        const { children, tooltipActiveClassName, showArrow, arrowClassName, contentClassName } = this.props;
        let tooltipClasses = cx(styles['tooltip'], styles['light'], this.props.tooltipClassName, styles[this.props.position], {
            [styles['active']]: this.state.active,
            [styles['fassured']]: !!this.props.fassured
        });
        // Moving this out of the previous cx function call because computed properties cannot be undefined, and this classname can potentially be undefined.
        if (tooltipActiveClassName && this.state.active) {
            tooltipClasses = cx(tooltipClasses, tooltipActiveClassName);
        }
        return (<div className={contentClassName}>
				<div ref={this.tooltipRef} className={tooltipClasses}>
					{showArrow ? <div className={cx(arrowClassName, styles['arrow'])}/> : null}
					<div className={cx(styles['wrapper'], this.props.wrapperClassName)}>
						<div className={cx(styles['container'], this.props.containerClassName)}>{children}</div>
					</div>
				</div>
				<div className={cx(styles['overlay'], this.props.overlayClassName)} onClick={this.handleClick}/>
			</div>);
    }
    render() {
        const { text } = this.props;
        return (<div className={cx(styles['help'], this.props.className)}>
				{text ? (<span className={cx(this.props.textClassName)} onClick={this.handleClick}>
						{text}
					</span>) : (<span className="question" onClick={this.handleClick}>
						?
					</span>)}
				{this.state.active ? this.renderContent() : null}
			</div>);
    }
}
Help.defaultProps = {
    position: 'bottom-right',
    showArrow: true
};
